export default "__VITE_ASSET__vFu3worp__"